import { Route as ReactRoute } from 'react-router';

function Route({ component: Component, ...children }: any): JSX.Element {
  return (
    <ReactRoute {...children} render={(props) => <Component {...props} />} />
  );
}

export default Route;
